import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';
import { FaExclamationCircle, FaHashtag } from 'react-icons/fa';
import PendenciaDocumentoItem from './PendenciaDocumentoItem';

const Card = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border-color: rgba(166, 3, 14, 0.2);
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`;

const RequestTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a2c3e;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: ${colors.red};
    font-size: 1.2rem;
  }
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: rgba(166, 3, 14, 0.1);
  color: ${colors.red};
  // Igual ao RequestCard: status longo quebra em vez de estourar o card
  max-width: 100%;
  overflow-wrap: anywhere;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
  gap: 12px;
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #eef2f6;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #5a6e7c;

  svg {
    color: ${colors.darkBlue};
    font-size: 0.9rem;
    opacity: 0.7;
  }

  strong {
    color: #1a2c3e;
    font-weight: 600;
    margin-right: 4px;
  }
`;

const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ItemDivider = styled.div`
  height: 1px;
  background: #eef2f6;
`;

// Um card por pedido (requerimentoId) — pode conter mais de uma pendência
// quando o mesmo pedido tem vários documentos indeferidos ao mesmo tempo,
// cada um com sua própria área de upload em PendenciaDocumentoItem.
const PendenciaGrupoCard = ({ grupo, onReenviado }) => {
  const total = grupo.pendencias.length;

  return (
    <Card>
      <CardHeader>
        <RequestTitle>
          <FaExclamationCircle />
          {grupo.nomePedido || `Requerimento ${grupo.numeroRequerimento}`}
        </RequestTitle>
        <StatusBadge>{total} documento{total > 1 ? 's' : ''} pendente{total > 1 ? 's' : ''}</StatusBadge>
      </CardHeader>

      <InfoGrid>
        <InfoItem>
          <FaHashtag />
          <strong>Nº do Pedido:</strong> {grupo.numeroRequerimento}
        </InfoItem>
        <InfoItem>
          <FaHashtag />
          <strong>Protocolo:</strong> {grupo.numeroProtocolo}
        </InfoItem>
      </InfoGrid>

      <ItemsList>
        {grupo.pendencias.map((pendencia, index) => (
          <React.Fragment key={pendencia.pendenciaId}>
            {index > 0 && <ItemDivider />}
            <PendenciaDocumentoItem pendencia={pendencia} onReenviado={onReenviado} />
          </React.Fragment>
        ))}
      </ItemsList>
    </Card>
  );
};

export default PendenciaGrupoCard;
